var render = function render(){var _vm=this,_c=_vm._self._c;return _c('record-presenter',{attrs:{"value":_vm.$store.state}})
}
var staticRenderFns = []

export { render, staticRenderFns }